
import { authorize } from "../../helper/authorize-token";
import superagent from "superagent";

const loadAllUsers = (token, page_token, wlf_id, view) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .get("/api/dashboard/user")
      .query( { page_token, wlf_id, view })
      .use(authorize(token))
      .then( res => {
        resolve({
          wlfs: res.body.data.wlfs,
          page_token: res.body.data.page_token,
          timestamp_sec: res.body.data.timestamp_sec,
        });
      });
  });
};

const loadMonthlyBillingCsv = (token, wlf_id) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/dashboard/get-monthly-billing-csv")
      .send({ wlf_id })
      .use(authorize(token))
      .then(res => {
        return resolve(res.body.data);
      })
  })
}

const loadWlfAUM = (token, wlf_id, page_token) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dashboard/wlf-aum")
      .send({ wlf_id, page_token })
      .use(authorize(token))
      .then(res => {
        return resolve(res.body.data);
      });
  })
}

const loadBillingDetail = (token, wlf_id, username, index) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dashboard/billing-detail")
      .send({ wlf_id, username, index })
      .use(authorize(token))
      .then(res => {
        return resolve(res.body.data);
      })
  })
}

const loadProxyOnboarding = (token, wlf_id, page_token) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dashboard/proxy-onboarding-users")
      .send({ wlf_id, page_token} )
      .use(authorize(token))
      .then(res => {
        return resolve(res.body.data);
      })
  });
}

const adminCreateUser = (
  token, first_name, last_name, wlf_id, email,
  //tda_account_number, delivery_type, envelope_id, phone_number) => {
  tda_account_number, delivery_type, onboarding_data) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/auth/admin-create-user")
      .send({
        first_name, last_name, wlf_id, email,
        tda_account_number, delivery_type, onboarding_data })
      .use(authorize(token))
      .then(res => {
        return resolve(res.body.data);
      })
  })
}

const adminDeleteUser = (token, username) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/dashboard/admin-delete-user")
      .send({ username })
      .use(authorize(token))
      .then(() => {
        return resolve();
      })
  })
}

const adminDeleteUserAcct = (token, username, index) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/dashboard/admin-delete-account")
      .send({ username, index })
      .use(authorize(token))
      .then(() => {
        return resolve();
      })
  })
}

const adminAddAccount = (
  token, username, tda_account_number, signing_type, envelope_id) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/auth/admin-add-account")
      .send({ username, tda_account_number, signing_type, envelope_id })
      .use(authorize(token))
      .then(res => {
        return resolve(res.body.data);
      })
  })
}

const createLPOAItem = (
  token, wlf_id, first_name, last_name, email, phone_number, account_number) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/docusign/create-lpoa-item")
      .send({ wlf_id, first_name, last_name, email, phone_number, account_number })
      .use(authorize(token))
      .then(res => {
        return resolve(res.body);
      })
  })
}

const getLPOAItems = (token) => {
  return new Promise((resolve) => {
    return superagent.agent()
      .post("/api/docusign/get-lpoa-items")
      .use(authorize(token))
      .then(res => {
        return resolve(res.body.payload);
      })
  })
}

const updateLPOAItem = (token, account_number) => {
  return new Promise((resolve) => {
    return superagent.agent()
      .post("/api/docusign/update-lpoa")
      .send({account_number})
      .use(authorize(token))
      .then(res => {
        return resolve(res.body);
      })
  })
}

const loadDynamoItems = (token, username) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dashboard/user-dynamo")
      .send({username})
      .use(authorize(token))
      .then(res => {
        return resolve(res.body.data);
      })
  })
}

const adminSetAccountState = (token, username, index, account_state) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/dashboard/admin-set-user-state")
      .use(authorize(token))
      .send({ username, index, account_state})
      .then(res => {
        return resolve(res.body);
      })
  })
}

const adminSetInvestmentAccountType = (token, username, index) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/dashboard/admin-set-investment-account-type")
      .use(authorize(token))
      .send({ username, index })
      .then(res => {
        return resolve(res.body);
      });
  })
}

const adminSetPortfolioFees = (token, index, userToUpdate, fees) => {
  return new Promise(resolve => {
    return superagent.agent()
    .post("/api/dashboard/admin-set-portfolio-fees")
    .use(authorize(token))
    .send({index, userToUpdate, ...fees})
    .then(res => {
      return resolve(res.body);
    })
  })
}

const adminResetPortfolioFees = (token, index, userToUpdate, fees) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/dashboard/admin-set-portfolio-fees/reset")
      .use(authorize(token))
      .send({index, userToUpdate, ...fees})
      .then(res => {
        return resolve(res.body);
      })
  })
}

const adminFullRebalance = (token, username, index) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/dashboard/calc-full-allocation")
      .use(authorize(token))
      .send({username, index})
      .then(res => {
        return resolve(res.body);
      })
  })
}

const adminUpdateProxyOnboarding = (token, acct_items) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/dashboard/admin-update-proxy-onboarding")
      .use(authorize(token))
      .send({acct_items})
      .then(res => {
        return resolve(res.body);
      })
  })
}

export { loadAllUsers, loadWlfAUM, loadProxyOnboarding, adminCreateUser,
  adminAddAccount, loadBillingDetail, loadMonthlyBillingCsv,
  adminDeleteUser, adminDeleteUserAcct, loadDynamoItems, adminSetAccountState,
  adminSetInvestmentAccountType, adminSetPortfolioFees, adminResetPortfolioFees, createLPOAItem,
  getLPOAItems, updateLPOAItem, adminFullRebalance, adminUpdateProxyOnboarding };
